import { TOAST_NOTIFICATION_ACTIONS } from "../../constants/Constants";

export const ToastNotificationReducer = (state, action) => {
  switch (action.type) {
    case TOAST_NOTIFICATION_ACTIONS.SHOW_SINGLE_TOAST:
      return { ...state, toasts: [action.payload] };
    case TOAST_NOTIFICATION_ACTIONS.SHOW_MULTIPLE_TOASTS:
      return { ...state, toasts: [...state.toasts, action.payload] };
    case TOAST_NOTIFICATION_ACTIONS.REMOVE_TOAST:
      return {
        ...state,
        toasts: state.toasts.filter((toast) => toast.id !== action.payload),
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/mySCC/common/reducers/ToastNotificationReducer.js